import {Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {SmartSummaryApiService} from "../../../../api/smart-summary-api.service";
import {MessagesService} from "../../../services/messages.service";
import {NgForm} from "@angular/forms";

@Component({
  selector: 'app-feedback-modal',
  templateUrl: './feedback-modal.component.html',
  styleUrls: ['./feedback-modal.component.scss']
})
export class FeedbackModalComponent {
  @Input() feedbackType!: 0 | 1; // 0 Negativo | 1 Positivo
  @ViewChild('feedbackForm') feedbackForm!: NgForm;
  feedbackFormModel: { text: string, rating: number } = {text: "", rating: 0};
  @Input() isOpen = false;
  @Output() closeModal = new EventEmitter<boolean>();
  @Input() idSinistro!: string;
  @Input() smartSummaryId!: string;

  constructor(private smartSummaryApiService: SmartSummaryApiService,
              private messagesService: MessagesService) {
  }

  setRating(value: number) {
    this.feedbackFormModel.rating = value;
  }

  closeFeedbackModal($event: any) {
    if (!$event.detail) {
      this.feedbackForm.resetForm();
      this.closeModal.emit(false);
    }
  }

  inviaFeedback() {
    this.smartSummaryApiService.sendSmartSummaryFeedback(this.feedbackType === 1, this.feedbackFormModel.rating, this.feedbackFormModel.text, this.idSinistro, this.smartSummaryId)
      .then((value) => {
        this.closeFeedbackModal({detail: false});
        this.messagesService.addMessage({text: value?.message, type: "success"});
      }).catch(() => {
      this.messagesService.addMessage({text: "Errore durante invio feedback", type: "error"});
    });
  }
}

